export type ChatSourceType =
  | 'dashboard sidebar'
  | 'marketing sidebar'
  | 'calendar sidebar'
  | 'settings sidebar'
  | 'menu sidebar'
  | 'team sidebar'
  | 'header'
  | 'header help menu'
  | 'clients import failure'
  | 'clients import'
  | 'clients list empty state'
  | 'debt blocked overlay'
  | 'online booking settings'
  | 'treatwell pay order status'
  | 'edit appointment modal';

export const chat_opened = (props: { service: 'Salesforce'; source: ChatSourceType }) => props;
